import { NgModule } from '@angular/core';
import { CrudDomComponent } from './crud-dom/crud-dom.component';
import { RouterModule } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { CommonModule } from '@angular/common';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { ListaFiltriCompilabiliModule } from './filtri/lista-filtri-compilabili/lista-filtri-compilabili.module';
import { CrudRowButtonComponent } from './crud-row-button/crud-row-button.component';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { CommonDirectivesModule } from '@alfercom/common-directives';
import { CommonPipesModule } from '@alfercom/common-pipes';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    ListaFiltriCompilabiliModule,
    RouterModule,
    NzTableModule,
    NzModalModule,
    NzButtonModule,
    NzDrawerModule,
    NzToolTipModule,
    NzPopoverModule,
    NzPopconfirmModule,
    CommonDirectivesModule,
    CommonPipesModule,
    TranslateModule
  ],
  declarations: [CrudDomComponent, CrudRowButtonComponent],
  entryComponents: [
  ],
  exports: [CrudDomComponent]
})
export class CrudServerSideModule { }
